import Chess from 'chess.js'

var SheepAndWolves = function(fen) {
  let chess = new Chess(fen)
  let movesMade = []
  
  function prevLetter(letter) {
    return String.fromCharCode(letter.charCodeAt(0) - 1);
  }
  function nextLetter(letter) {
    return String.fromCharCode(letter.charCodeAt(0) + 1);
  }

  function isValidSquare(square) {
    let color = chess.square_color(square)
    return color === 'light' || color === 'dark'
  }

  function rank(square) {
    return parseInt(square[1])
  }
  function file(square) {
    return square[0]
  }

  function diagonals(square) {
    return [
      prevLetter(file(square)) + (rank(square) - 1),
      prevLetter(file(square)) + (rank(square) + 1),
      nextLetter(file(square)) + (rank(square) - 1),
      nextLetter(file(square)) + (rank(square) + 1)
    ].filter(s => isValidSquare(s))
  }

  function validMoves(s) {
      const piece = chess.get(s);
      if (piece) {
        if (piece.type === chess.KING) {
          return diagonals(s).filter(s => !chess.get(s))
        }
        else if (piece.type === chess.PAWN) {
          // two forward diagonals
          return diagonals(s)
            .filter(square => rank(square) > rank(s))
            .filter(s => !chess.get(s))
        }
      }
      return []
  }
  
  function turnColor() {
    return (chess.turn() === 'w') ? 'white' : 'black'
  }

  function colorMoves(color) {
    const moves = []
    chess.SQUARES.forEach(s => {
      let piece = chess.get(s);
      if (piece && piece.color === color) {
        for (let sq of validMoves(s)) {
          moves.push({ from: s, to: sq })
        }
      }
    })
    return moves;
  }

  function blackReachedFirstRank() {
    for (let file of ['a', 'c', 'e', 'g']) {
      let square = file + '1'
      let piece = chess.get(square)
      if (piece && piece.color === 'b')
        return true
    }
    return false;
  }

  function winner() {
    if (blackReachedFirstRank()) {
      return 'b';
    } else if (chess.turn() === 'b' && colorMoves('b').length === 0) {
      return 'w';
    } else if (chess.turn() === 'w' && colorMoves('w').length === 0) {
      return 'b';
    } else {
      return null;
    }
  }

  function mostForwardMove(moves, color) {
    let more_agg_rank = (r1, r2) => {
      if (color === 'w')
        return r1 > r2
      else
        return r1 < r2
    }
    let f = (move1, move2) => 
        more_agg_rank(rank(move1), rank(move2)) ? move1 : move2
    return moves.reduce(f)
  }

  function makeMove(move, undo) {
    let { from, to } = move;
    if (!undo) movesMade.push(move);
    let piece = chess.get(from);
    chess.remove(from);
    if (!piece) {
      console.log('no piece there')
      console.log(move)
      console.log(chess.ascii())
    }
    let can_put = chess.put(piece, to);
    if (!can_put) {
      console.log("put piece failed:")
      console.log(move)
      console.log(chess.ascii())
    }
    let new_turn = chess.turn() === 'w' ? 'b' : 'w';
    chess.setTurn(new_turn);
  }

  let undoMove = () => {
    let move = movesMade.pop()
    makeMove({ from: move.to, to: move.from }, true)
  }

  let moveWithLeastWinningCounters = (moves, color, isWinning) => {
    let otherColor = color === 'w' ? 'b' : 'w'
    
    let numWinningCounters = move => {
      makeMove(move);
      let counters = colorMoves(otherColor);
      let numWinning = 0;
      for (let counter of counters) {
        if (isWinning(counter, otherColor))
          numWinning += 1
      }
      undoMove();
      return numWinning;
    }

    let reduce = (move1, move2) => {
      let numWinningCounters1 = numWinningCounters(move1)
      let numWinningCounters2 = numWinningCounters(move2)
      return (numWinningCounters1 > numWinningCounters2) ? move2 : move1 
    }
    return moves.reduce(reduce)
  }

  function lastMove() {
    if (movesMade.length > 0) {
      return movesMade[movesMade.length - 1]
    } else {
      return null
    }
  }

  /***************************************************************************
   * PUBLIC API 
   **************************************************************************/
  return {
    makeMove,
    undoMove,
    fen: () => chess.fen(),
    allSquares: () => chess.SQUARES,
    turn: () => chess.turn(),
    turnColor,
    validMoves,
    colorMoves,
    whiteMoves: () => colorMoves('w'),
    blackMoves: () => colorMoves('b'),
    winner,
    rank,
    lastMove,
    
    movable() {
      const dests = {}
      chess.SQUARES.forEach(s => dests[s] = validMoves(s))
      // console.log(turnColor());
      return {
        free: false,
        dests,
        color: this.turnColor(),
        showDests: true
      }
    },

    // things that relate to heuristic AI
    mostForwardMove,
    moveWithLeastWinningCounters,
    
    dummy: () => "no trailing comma is annoying"
  };
}

export default SheepAndWolves;
